module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAFHSURBVDiNrZGxTgJBEIb/2YXE8h7hLIyFFkdsbO3ISeKZeOTKDdKjT+BZ2fIC6tEZKaQwaAdPoFhooYVnaUctLmOheyHA3Un0r2b/mfnyZ4eQo3KgbDkuNJg/W912NMialVnN7b3agWBxA2CTIIKVtdL7y9N9KjAVVqnWQwAnE9YSgbzV9Q16frzrz9uhacPzlPVRlOcEeBmho+JIH3Y60TAVVg6ULbXsAbAzQEYDLfXu7UUUG0OYwvWVswAIABypZc/1lWMMCXx/NJG4AmD9EmRkTR6GKtV6yMxHC0JmRETHgpl3/goCAGZuiOJIb4GgAAzzFlI0BEFpqUvJNV2/9koge+FE4LjbPlsGgELObExAk+knNSNExrWzYYTw+vK0ZZ4Vf99ioJk2LtIa85Qk/A9YnhIYgfrTTRrT2+SbWTzMzIBiU38BO5Nko/nNVE0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/yy8.png
// module id = Trlr
// module chunks = 1